import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Angle"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M6.74966 17.9999C6.67396 17.4794 6.44408 16.9935 6.08966 16.6049L13.2372 4.16992L11.9397 3.41992L4.76216 15.8399C4.55495 15.7801 4.34034 15.7498 4.12466 15.7499C2.8229 15.7454 1.71443 16.6955 1.51993 17.9827C1.32543 19.2699 2.10365 20.5051 3.34864 20.8854C4.59363 21.2657 5.92925 20.6761 6.48716 19.4999H20.9997V17.9999H6.74966ZM14.9902 16.9199H16.4902C16.4898 13.7793 14.9767 10.8311 12.4252 8.99988L11.5552 10.2149C13.7134 11.7661 14.9921 14.262 14.9902 16.9199ZM2.99963 18.3749C2.99963 18.9963 3.50331 19.4999 4.12463 19.4999C4.74595 19.4999 5.24963 18.9963 5.24963 18.3749C5.24963 17.7536 4.74595 17.2499 4.12463 17.2499C3.50331 17.2499 2.99963 17.7536 2.99963 18.3749Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Angle.vue"]]);
